// extracted by mini-css-extract-plugin
export var divider = "_yr-0";